module.exports = __webpack_public_path__ + "img/undraw_Choose_re_7d5a.070172f6.svg";